<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import './assets/styles/common.css'
import Tab from '@/components/Index/tab.vue'
import Sidebar from '@/views/layout/components/Sidebar/index.vue'
import { mapActions } from 'vuex'
import Cookies from 'js-cookie'

export default {
  name: 'App',
  components: {
    Tab,
    Sidebar
  },
  methods: {
    ...mapActions([
      'RefreshApp',
      'RefreshConfig',
    ])
  },
  async mounted () {
    let _token = Cookies.get('loginToken')
    if (_token && this.$route.name != 'Account') {
      // 每次刷新更新 appList
      await this.RefreshApp().then()
      this.RefreshConfig()
    }
  }
}
</script>

<style>
#app {
  width: 100%;
  height: 100vh;
  background: #f5f5f7;
}
.flex__center {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.flex__between {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.flex__right {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
/* 富文本显示 */
#rich__box *{
  max-width: 100%!important;
  font-size: inherit;
  margin: 0;
  padding: 0;
  /* font-style: normal; */
  box-sizing: border-box !important;
  -webkit-box-sizing: border-box !important;
  word-wrap: break-word !important;
}
#rich__box ul {
  list-style-type: disc!important;
  list-style-position: inside!important;
}
#rich__box ol {
  list-style-type: decimal!important;
  list-style-position: inside!important;
}
/* 富文本显示 */
.logOut .el-button--default{
  display: none
}
.logOut .el-button--primary{
  display: inline-block
}
.tox-tinymce-aux {
  z-index: 3000!important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue